import React from 'react';
export const Hero = () => {
  return <section className="w-full pt-40 pb-16 px-6 md:px-12 bg-white transition-colors" data-id="element-53">
      <div className="max-w-7xl mx-auto" data-id="element-54">
        <h1 className="text-[clamp(2.2rem,5vw,4rem)] font-semibold text-[#070707] leading-[1.2] mb-6 tracking-tight transition-colors" data-id="element-55">
          We are an early stage venture capital fund specializing in all things
          enterprise & infrastructure.
        </h1>
      </div>
    </section>;
};